import "./App.css";
import { Login } from "./components/authentication/login";
import { FlockComposition } from "./components/flocks/Flocks";
import { LanguageSwitcher } from "./components/languageSwitcher/LanguageSwitcher";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { getParams } from "./utils/params";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SigninHeader } from "./components/campagne/signinHeader";
import { SigninDetails } from "./components/campagne/signinDetails";
import { Container } from "./components/Container";
import { VenueLogoList } from "./components/venue-logo-list/venue-logo-list";

function App() {
    const queryClient = new QueryClient();
    const { i18n } = useTranslation();

    const paramLanguage = getParams("lang");
    const isPresales = getParams("destination") === "presales";

    useEffect(() => {
        i18n.changeLanguage(paramLanguage);
    }, [i18n, paramLanguage]);

    return (
        <QueryClientProvider client={queryClient}>
            <main className="pt-4 h-auto lg:h-screen">
                <FlockComposition composition="home">
                    <LanguageSwitcher />
                    <Container className="flex flex-col gap-8 mt-12 lg:mt-16 lg:grid lg:grid-cols-[1fr_minmax(400px,600px)]">
                        <SigninHeader isPresales={isPresales} />

                        <div className="lg:row-span-2 mx-auto">
                            <img
                                src="/assets/beat/logo/logo.svg"
                                alt="my beat"
                                width="220"
                                className="hidden lg:block mx-auto mt-14 mb-2"
                            />
                            <Login />
                        </div>

                        <SigninDetails isPresales={isPresales} />
                    </Container>
                    <VenueLogoList />
                </FlockComposition>
            </main>
            <footer className="relative">
                <FlockComposition
                    className="overflow-visible"
                    composition="footer"
                ></FlockComposition>
            </footer>
        </QueryClientProvider>
    );
}

export default App;
